export const presenceStrings: Record<string, [string, string, string]> = {
  'presence.bindingInvalid': [
    '機台綁定無效，請先返回機台設定確認。',
    'Invalid device binding. Check device settings first.',
    '端末登録が無効です。端末設定を確認してください。',
  ],
  'presence.cameraTitle': [
    '鏡頭與服務邀請',
    'Camera and service invitation',
    'カメラとサービス案内',
  ],
  'presence.cameraEntry': ['設定鏡頭', 'Camera settings', 'カメラ設定'],
  'presence.enabled': ['已啟用', 'Enabled', '有効'],
  'presence.disabled': [
    '已停用 · 完成試測與校正後可啟用',
    'Disabled · Test and calibrate to enable',
    '無効 · テストと調整後に有効化',
  ],
  'presence.invitation': ['服務邀請', 'How can we help?', 'サービスのご案内'],
  'presence.greeting': [
    '您好，需要什麼服務或幫助嗎？',
    'Hello! How can I help you?',
    'こんにちは。お手伝いしましょうか？',
  ],
  'presence.greetingSub': [
    '可以幫您推薦行程、查詢班次與票價，或直接購票。',
    'Explore trips, check departures and fares, or buy tickets.',
    'おすすめの旅程、出発時刻や料金、チケットをご案内します。',
  ],
  'presence.accept': ['查看服務', 'View services', 'サービスを見る'],
  'presence.dismiss': ['暫時不用', 'Not now', '今は不要'],
  'presence.remaining': ['自動收起倒數', 'Closes in', '自動終了まで'],
  'presence.seconds': ['秒', 'seconds', '秒'],
  'presence.ms': ['毫秒', 'ms', 'ミリ秒'],
  'presence.back': ['← 返回機台設定', '← Device settings', '← 端末設定へ'],
  'presence.intro': [
    '旅客停留後，在首頁顯示服務邀請。請先試測鏡頭並校正互動區。',
    'Invite visitors who pause at the home screen. Test the camera and calibrate the interaction area.',
    'ホーム画面で立ち止まったお客様をご案内します。カメラをテストし、範囲を調整してください。',
  ],
  'presence.unbound': ['尚未綁定機台', 'Device not bound', '端末未登録'],
  'presence.localOnly': [
    '設定僅儲存在本機',
    'Settings stored on this machine',
    '設定はこの端末にのみ保存',
  ],
  'presence.auto': ['自動服務邀請', 'Automatic invitation', '自動案内'],
  'presence.serial': [
    '相機序號（單台可留白）',
    'Camera serial (optional for one camera)',
    'カメラ番号（1台の場合は省略可）',
  ],
  'presence.test': ['試測鏡頭', 'Test camera', 'カメラテスト'],
  'presence.preview': ['本機即時校正影像', 'Local calibration preview', '端末内の調整用プレビュー'],
  'presence.starting': ['正在啟動鏡頭…', 'Starting camera…', 'カメラを起動中…'],
  'presence.frameDelayed': [
    '影格更新延遲，暫時顯示最近影像；恢復後即可繼續校正。',
    'Frames are delayed. Showing the latest image; calibration resumes when updates recover.',
    '映像の更新が遅れています。直近の画像を表示中です。更新が回復すると調整を再開できます。',
  ],
  'presence.testFirst': [
    '請先選擇鏡頭並開始試測',
    'Select and test a camera first',
    'カメラを選択してテストしてください',
  ],
  'presence.legend': [
    '綠框：進入互動區　金框：離開判定範圍；金框須包住綠框。',
    'Green: entry area. Gold: exit area; it must contain the green area.',
    '緑：入場範囲、金：退場判定範囲。金枠は緑枠を囲む必要があります。',
  ],
  'presence.calibration': ['互動區校正', 'Interaction area calibration', '範囲調整'],
  'presence.enter_roi': ['進入區', 'Entry', '入場範囲'],
  'presence.exit_roi': ['離開區', 'Exit', '退場範囲'],
  'presence.x': ['X 位置', 'X', 'X 位置'],
  'presence.y': ['Y 位置', 'Y', 'Y 位置'],
  'presence.width': ['寬度', 'Width', '幅'],
  'presence.height': ['高度', 'Height', '高さ'],
  'presence.min_area': ['人物最小面積', 'Minimum person area', '人物の最小面積'],
  'presence.confidence': ['信心門檻', 'Confidence threshold', '信頼度しきい値'],
  'presence.near': ['最近距離', 'Near distance', '最短距離'],
  'presence.far': ['最遠距離', 'Far distance', '最長距離'],
  'presence.advanced': ['進階設定', 'Advanced settings', '詳細設定'],
  'presence.detection_interval_ms': ['人物辨識間隔', 'Detection interval', '人物検出間隔'],
  'presence.intervalHint': [
    '可設定 50～200 毫秒，預設 100。間隔越短，反應越快、電腦負擔越高；實際速度受運算效能影響。',
    '50–200 ms; default 100. Shorter intervals respond faster and use more processing power. Actual speed depends on hardware.',
    '50～200ミリ秒、初期値100。短い間隔は反応が速く、処理負荷が高くなります。実際の速度は機器に依存します。',
  ],
  'presence.perSecond': ['次／秒（預估）', 'detections/second (estimated)', '回／秒（目安）'],
  'presence.rules': ['邀請與離開規則', 'Invitation and departure rules', '案内と退場の設定'],
  'presence.dismiss_on_leave': [
    '人物離開時收起邀請',
    'Dismiss when the visitor leaves',
    'お客様が離れたら案内を閉じる',
  ],
  'presence.leaveHint': [
    '關閉時保留邀請至時間到或旅客操作。相機中斷與資料過期仍會收起邀請。',
    'When off, keep the invitation until timeout or interaction. Camera failures and stale data still dismiss it.',
    '無効時は時間切れか操作まで表示します。カメラ異常やデータ停止時は終了します。',
  ],
  'presence.dwell_seconds': ['停留多久才邀請', 'Dwell before invitation', '案内までの滞在時間'],
  'presence.invite_seconds': [
    '邀請最長顯示時間',
    'Maximum invitation duration',
    '案内の最大表示時間',
  ],
  'presence.lost_seconds': [
    '人物消失容忍時間',
    'Missing person tolerance',
    '人物検出の途切れ許容時間',
  ],
  'presence.cooldown_seconds': [
    '再次邀請冷卻時間',
    'Cooldown before next invitation',
    '次の案内までの待機時間',
  ],
  'presence.vacancy_seconds': ['連續無人確認時間', 'Continuous vacancy duration', '無人確認時間'],
  'presence.require_vacancy': [
    '再次邀請前，需確認連續無人',
    'Require vacancy before another invitation',
    '次の案内前に無人を確認する',
  ],
  'presence.vacancyHint': [
    '取消勾選後，冷卻結束即可重新累積停留；同一人持續站著也可能再次收到邀請。秒數停用但保留。',
    'When off, a visitor who stays may receive another invitation after cooldown and a new dwell. The duration is retained.',
    '無効時は待機後に再度滞在時間を計測し、同じ人にも案内する場合があります。秒数は保持されます。',
  ],
  'presence.privacy': [
    '影像僅在本機處理，不錄影、不儲存、不上傳。更換鏡頭或移動機台後請重新試測校正。',
    'Images stay on this machine and are not recorded, stored or uploaded. Recalibrate after moving the camera or kiosk.',
    '画像は端末内で処理し、録画・保存・送信しません。カメラや端末の移動後は再調整してください。',
  ],
  'presence.save': ['儲存校正', 'Save calibration', '調整を保存'],
  'presence.saved': [
    '已儲存於本機；返回首頁後開始偵測。',
    'Saved locally. Return home to start detection.',
    '端末に保存しました。ホームに戻ると検出を開始します。',
  ],
  'presence.unsaved': [
    '設定已修改，請儲存校正。',
    'Settings changed. Save calibration to apply.',
    '変更しました。調整を保存してください。',
  ],
  'presence.invalid': [
    '設定無效，請檢查數值、範圍與試測狀態。',
    'Invalid settings. Check values, areas and camera test.',
    '数値、範囲、テスト状態を確認してください。',
  ],
  'presence.failed': [
    '操作失敗，請檢查本機服務後重試。',
    'Operation failed. Check the local service and retry.',
    '処理できません。端末のサービスを確認してください。',
  ],
  'presence.disable': ['停用自動邀請', 'Disable automatic invitation', '自動案内を無効にする'],
};
